/**
 * Created by Ning Jiang on 2021-05-21.
 */

import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Oktoberfest} from "../Oktoberfest";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {OktoberfestReelController} from "../reels/OktoberfestReelController";
import {ReelState} from "../../core/reel/ReelState";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {OktoberfestReelDividers} from "../view/OktoberfestReelDividers";
import {GameHelper} from "../../core/utils/GameHelper";

export class OktoberfestNormalResultPresentation implements FlowStatePresentation {
    private _reelNormalStopDelay: number[] = [0, 0.3, 0.3, 0.3, 0.3];
    private _reelFastStopDelay: number[] = [0, 0.1, 0.1, 0.1, 0.1];
    private _reelNearWinStopDelay: number[] = [3.0, 3.0, 3.0, 3.0, 3.0];
    private _defaultSpinDuration: number;
    private _partyStopDelay: number = 4.5;
    private _prostSpinDelay: number[] = [3, 0, 0, 0, 3];
    private _isPartySpin: boolean = false;

    constructor() {
    }

    public start(flowStateController: FlowStateController): void {
        let wildIndex: number = -1;
        if (Oktoberfest.model.parsedGameData) {
            wildIndex = Oktoberfest.model.parsedGameData.overlayWilds[2].indexOf("W");
            this._isPartySpin = Oktoberfest.model.parsedGameData.mode == "STACKED_PARTY_SPIN";
        }
        flowStateController.setSkipCallback(() => this.skip());
        Oktoberfest.reelStopPresentations.start().then(res => flowStateController.finish());
        if (this._isPartySpin) {
            Oktoberfest.partyMode.onPartyStart({
                partySymbol: Oktoberfest.model.parsedGameData.stackedModeSymbol
            })
        }
        if (!this._isPartySpin && wildIndex > 0) {
            Oktoberfest.nudgeWildCont.initAnimations();
        }
        if (!this._defaultSpinDuration) {
            // This simple calculation doesn't cover strange stopping order.
            this._defaultSpinDuration = ArrayHelper.arraySum(this._reelNormalStopDelay) + Oktoberfest.reels[4].getDefaultStoppingTime();
        }

        let delay = 0;
        // The spin time should not leak there is feature later, like a near win. so I use a default spin time here to calculation Jurisdiction padding.
        // fastSpin is off when there is spin time limit, so we don't need to consider it here. To change if something changed.
        const padding = Oktoberfest.gameFlowController.calculatePaddingDuration(this._defaultSpinDuration);
        if (padding > 0) {
            //Logger.logDev("Added minimum jurisdiction padding  ", padding);
            delay += padding;
        }
        this.getReelsStopResult(false, delay);
    }

    public finish(): void {
        console.log("allReelsStopped");
    }

    private getReelsStopResult(quickStop: boolean, delay: number): void {
        let spinStopOffset: number = 0;
        Oktoberfest.reels.forEach((spinReel: OktoberfestReelController, reelId: number) => {
            if (spinReel.reelState === ReelState.SPIN) {
                spinStopOffset = Math.max(
                    spinStopOffset,
                    spinReel.getSpinStopOffset());
            }
        });

        Oktoberfest.reels.forEach((reel, reelId) => {
            delay += this.getReelStopDelay(reel, quickStop); // This is a rough estimated time, the reel will take the real time when it's stopping.
            reel.tryStop(spinStopOffset, delay, quickStop, () => {
            });
        });
    }

    private getReelStopDelay(reel: OktoberfestReelController, quickStop: boolean): number {
        OktoberfestReelDividers.toPlayAttentionOnReel1 = GameHelper.toPlayAttentioOn1stReel();
        if (reel.reelState === ReelState.INACTIVE || reel.reelState === ReelState.STOPPING || reel.reelState === ReelState.STOPPED) {
            return 0;
        }

        if (quickStop) {
            return this._reelFastStopDelay[reel.reelId];
        }
        if (Oktoberfest.model.parsedGameData && Oktoberfest.model.parsedGameData.overlayWilds[2][0] === null) {
            if (Oktoberfest.model.parsedGameData.mode == "WILD_RESPIN" && ( Oktoberfest.model.parsedGameData.nextMode == "WILD_RESPIN" || Oktoberfest.model.parsedGameData.nextMode == "NORMAL" )) {
                return this._prostSpinDelay[reel.reelId];
            }
        }
        if (reel.hasNearWin()) {
            return this._reelNearWinStopDelay[reel.reelId];
        }
        if (this._isPartySpin && reel.reelId === 0) {
            return this._partyStopDelay;
        }
        if (Oktoberfest.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            return this._reelFastStopDelay[reel.reelId];
        }
        return this._reelNormalStopDelay[reel.reelId];
    }

    private skip(): void {
        Logger.logDev("skip result");
        if (Oktoberfest.nudgeWildCont) {
            Oktoberfest.nudgeWildCont.skip();
        }
        this.getReelsStopResult(true, 0);
        Oktoberfest.reelStopPresentations.skip();
    }
}